import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ProductCardData} from "../../../../types/product-card-data.types";
import {baseUrl} from "../../../../../../../core/constants/base-url";
import {Observable} from "rxjs";
import {RecordsDataRequestQueryParams} from "../../../../../../../core/types/records-table.types";
import {SyncProductCard} from "../types/product-card-sync-modal.types";

@Injectable({
  providedIn: 'root'
})
export class ProductCardSyncApiService {
  private http: HttpClient = inject(HttpClient);
  private url: string = `${baseUrl}/product-cards`;

  public fetchProductCardsList(params: RecordsDataRequestQueryParams): Observable<Array<ProductCardData>> {
    return this.http.get<Array<ProductCardData>>(`${this.url}/unlinked-product-cards`, { params: params });
  }

  public fetchSyncProductCardsList(params: RecordsDataRequestQueryParams): Observable<Array<ProductCardData>> {
    return this.http.get<Array<ProductCardData>>(`${this.url}/linked-product-cards`, { params: params });
  }

  public attachProductCard(params: SyncProductCard): Observable<void> {
    return this.http.post<void>(`${this.url}/link-product-cards`, params);
  }

  public detachProductCard(params: SyncProductCard): Observable<void> {
    return this.http.delete<void>(`${this.url}/unlink-product-cards`, { body: params });
  }
}
